var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('vue-apex-charts',{key:("" + (_vm.series.length) + (_vm.options.length)),ref:("simple-donut-" + _vm.name),attrs:{"type":"donut","height":_vm.height,"options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }